<template>
  <div  class="payment-page-iframe"
        :class="[ {'modal-view' : isModalView},
        ]">

    <!-- Payment process breadcrumbs -->
    <section class="payment-page-child payment-page-breadcrumbs">
      <div class="payment-step">
        <span>{{ $t('plans.select-packed-title') }}</span>
        <div @click="showPaymentStep = 'packed'" class="point" :class="[{'active' : showPaymentStep === 'packed'}]"></div>
      </div>
      <div class="payment-step">
        <span>{{ $t('plans.select-account-title') }}</span>
        <div @click="showPaymentStep = 'account'" class="point" :class="[{'active' : showPaymentStep === 'account'}]"></div>
      </div>
      <div class="payment-step">
        <span>{{ $t('plans.pay-title') }}</span>
        <div @click="showPaymentStep = 'pay'" class="point" :class="[{'active' : showPaymentStep === 'pay'}]"></div>
      </div>
    </section>

    <!--  Step 1 - Choose Plan -->
    <section class="payment-page-child payment-page-packed s-form-card-container s-scroll"
             :class="[ {'' : isModalView},]" v-show="showPaymentStep === 'packed'">
      <s-plans-container @toNextStep="showPaymentStep = 'account'"  :planSubscribed="planSubscribed" :plan-selected="planSelected" @planSelected="planSelected = $event" @togglePrice="togglePrice = $event" @storageSelected="storageSelected = $event"></s-plans-container>
    </section>

    <!--  Step 2 - Choose Account -->
    <section class="payment-page-child payment-page-account s-form-card-container s-scroll"
             :class="[ {'' : isModalView},]" v-if="showPaymentStep === 'account'">
      <SignUpForm @toNextStep="showPaymentStep = 'pay'" form-type="payment"/>

    </section>

    <!--  Step 3 - Pay -->
    <section class="payment-page-child payment-page-pay s-form-card-container s-scroll"
             :class="[ {'' : isModalView},]" v-if="showPaymentStep === 'pay'">

      <div class="payment-page-pay-child details">
        <span class="">{{ $t('plans.your-selected-title') }} {{ !togglePrice? $t('plans.monthly-title') : $t('plans.annually-title') }} {{ $t('plans.plan-title') }}:</span>
        <s-plan-details
          class="s-no-pointer"
          isSelected
          toPay
          :planName="planSelected"
          :togglePrice="togglePrice"
        ></s-plan-details>
        <span class="storage-extension" v-if="planSelected === 'master' && storageSelected === '1'"> + 1TB<s-badge class="s-badge-green">{{ !togglePrice ? '$35' : '$350' }}</s-badge>{{ $t('plans.storage-extension-title') }}</span>
        <span class="storage-extension" v-if="planSelected === 'master' && storageSelected === '2'"> + 4TB<s-badge class="s-badge-green">{{ !togglePrice ? '$65' : '$650' }}</s-badge>{{ $t('plans.storage-extension-title') }}</span>
      </div>

      <div class="payment-page-pay-child method">
        <span>{{ $t('plans.choose-payment-method-title') }} <br></span>
        <div @click="paymentSelected = 'paypal'" class="payment-method-card s-pointer" :class="[{'selected' : paymentSelected === 'paypal'}]">
          <s-button class="s-button-payment-method"  iconImage="Web_Paypal_Color_SVG.svg">PayPal</s-button>
        </div>
        <div @click="paymentSelected = 'fastspring'" class="payment-method-card s-pointer" :class="[{'selected' : paymentSelected === 'fastspring'}]">
          <s-button class="s-button-payment-method"  iconImage="Web_Fastspring_Color_SVG.svg">Fastspring</s-button>
        </div>
        <div @click="paymentSelected = 'bitcoin'" class="payment-method-card s-pointer" :class="[{'selected' : paymentSelected === 'bitcoin'}]">
          <s-button class="s-button-payment-method"  iconImage="Web_Bitcoin_Color_SVG.svg">Bitcoin</s-button>
        </div>

        <div @click="paymentSelected = 'debit'" class="payment-method-card s-pointer" :class="[{'selected' : paymentSelected === 'debit'}]">
          <s-button class="s-button-payment-method"  iconImage="">Debit</s-button>
        </div>
<!--        <div @click="paymentSelected = 'credit'" class="payment-method-card s-pointer" :class="[{'selected' : paymentSelected === 'credit'}]">-->
<!--          <s-button class="s-button-payment-method"  iconImage="">Credit</s-button>-->
<!--        </div>-->
<!--        <div @click="paymentSelected = 'transfer'" class="payment-method-card s-pointer" :class="[{'selected' : paymentSelected === 'transfer'}]">-->
<!--          <s-button class="s-button-payment-method"  iconImage="">Transfer</s-button>-->
<!--        </div>-->
      </div>

      <div class="payment-page-pay-child total" :class="[{'button-disabled' : paymentSelected === ''}]">
        <span>{{ $t('plans.total-payment-title') }}: ${{ !togglePrice ? planPriceMonthly : planPriceAnnually }}<sup>{{ togglePrice ? '50' : '95' }}</sup><br></span>

        <s-button @click="$emit('toNextStep')"  class="s-button-upgrade-fill lite s-button-pillborder s-button-height s-margin-auto"   :class="{'s-button-link-hover' : paymentSelected !== ''}" iconFontAfter="s-icon-plan-lite"  v-if="planSelected === 'lite'" >{{ $t('actions.subscribe-to-lite') }}</s-button>

        <s-button @click="$emit('toNextStep')"  class="s-button-upgrade-fill basic s-button-pillborder s-button-height s-margin-auto"  :class="{'s-button-link-hover' : paymentSelected !== ''}"  iconFontAfter="s-icon-plan-basic"  v-if="planSelected === 'basic'" >{{ $t('actions.subscribe-to-basic') }}</s-button>

        <s-button @click="$emit('toNextStep')"  class="s-button-upgrade-fill pro s-button-pillborder s-button-height s-margin-auto"    :class="{'s-button-link-hover' : paymentSelected !== ''}"  iconFontAfter="s-icon-plan-pro"    v-if="planSelected === 'pro'"   >{{ $t('actions.subscribe-to-pro') }}</s-button>

        <s-button @click="$emit('toNextStep')"  class="s-button-upgrade-fill master s-button-pillborder s-button-height s-margin-auto" :class="{'s-button-link-hover' : paymentSelected !== ''}"  iconFontAfter="s-icon-plan-master" v-if="planSelected === 'master'">{{ $t('actions.subscribe-to-master') }}</s-button>
      </div>


    </section>

    <section class="payment-page-child payment-page-back">
      <s-button @click="goBack" class="s-button-height s-button-white">{{ $t('actions.go-back') }}</s-button>
    </section>

  </div>
</template>

<script>

import SButton from '@/components/SButton.vue'
import SPlansContainer from '@/components/SPlansContainer.vue'
import SPlanDetails from '@/components/SPlanDetails.vue'
import SBadge from '@/components/SBadge.vue'
import SignUpForm from "@/components/SignUpForm.vue";

export default {
  components: {
    SignUpForm,
    SButton,
    SPlansContainer,
    SPlanDetails,
    SBadge,
  },
  props: {
  },
  data () {
    return {
      planSubscribed: 'start',
      planSelected: 'pro',
      togglePrice: false,
      storageSelected: 0,
      showPaymentStep: 'packed',
      paymentSelected: '',
      isModalView: false
    }
  },
  computed: {
    planPriceMonthly() {
      if (this.planSelected === 'trial') return this.$t('plans.free-title')
      if (this.planSelected === 'lite') return '2'
      if (this.planSelected === 'basic') return '6'
      if (this.planSelected === 'pro') return '9'
      if (this.planSelected === 'master' && this.storageSelected === 0) return '19'
      if (this.planSelected === 'master' && this.storageSelected === '1') return '54'
      if (this.planSelected === 'master' && this.storageSelected === '2') return '84'
      return ''
    },
    planPriceAnnually() {
      if (this.planSelected === 'trial') return this.$t('plans.free-title')
      if (this.planSelected === 'lite') return '29'
      if (this.planSelected === 'basic') return '69'
      if (this.planSelected === 'pro') return '99'
      if (this.planSelected === 'master' && this.storageSelected === 0) return '199'
      if (this.planSelected === 'master' && this.storageSelected === '1') return '549'
      if (this.planSelected === 'master' && this.storageSelected === '2') return '849'
      return ''
    }
  },
  methods: {
    goBack () {
      if (this.showPaymentStep === 'packed') return this.$router.push('/');
      else if (this.showPaymentStep === 'account') return this.showPaymentStep = 'packed';
      else if (this.showPaymentStep === 'pay') return this.showPaymentStep = 'account';
    }
  }
}
</script>
